/**
 * US state resident population (Census Bureau 2024 vintage estimates,
 * rounded to thousands). Static on purpose — drives "customers per 100k
 * people" market penetration (Praxis pattern: raw revenue-by-state just
 * mirrors population; per-capita shows actual traction). Refresh ~yearly.
 */
export const US_POPULATION: Record<string, number> = {
  AL: 5_157_000, AK: 740_000, AZ: 7_582_000, AR: 3_088_000, CA: 39_431_000,
  CO: 5_957_000, CT: 3_675_000, DE: 1_051_000, FL: 23_372_000, GA: 11_180_000,
  HI: 1_446_000, ID: 2_001_000, IL: 12_710_000, IN: 6_924_000, IA: 3_241_000,
  KS: 2_970_000, KY: 4_588_000, LA: 4_597_000, ME: 1_405_000, MD: 6_263_000,
  MA: 7_136_000, MI: 10_140_000, MN: 5_793_000, MS: 2_943_000, MO: 6_245_000,
  MT: 1_137_000, NE: 2_005_000, NV: 3_267_000, NH: 1_409_000, NJ: 9_500_000,
  NM: 2_130_000, NY: 19_867_000, NC: 11_046_000, ND: 796_000, OH: 11_883_000,
  OK: 4_095_000, OR: 4_272_000, PA: 13_078_000, RI: 1_112_000, SC: 5_478_000,
  SD: 924_000, TN: 7_227_000, TX: 31_290_000, UT: 3_503_000, VT: 648_000,
  VA: 8_812_000, WA: 7_958_000, WV: 1_769_000, WI: 5_960_000, WY: 587_000,
  DC: 702_000, PR: 3_203_000,
};

/** Customers (or any count) per 100k residents; null when we lack population. */
export function per100k(state: string, count: number): number | null {
  const pop = US_POPULATION[state];
  return pop !== undefined && pop > 0 ? (count / pop) * 100_000 : null;
}
